export class CRMContato {
    id: number;
    nome: string;
    fone1: string;
    fone2: string;
    email: string;
    rua: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    uf: string;
    cep: string;
    obs: string;
    idCliente: number;
    ibge: string;
    contato: string;
    franquia: number;
}  